import React from 'react';
import PropTypes from 'prop-types';

import { FormProvider } from 'react-hook-form';

import { t } from 'i18next';

import {
  Box,
  Button,
  FormEmailField,
  Label,
  styled,
  Typography,
} from '@datanomik/commons-ui';

import Grid from '@/views/common/Grid';
import Modal from '@/views/common/Modal';

import styles from './styles';
import useForgotPassword from './hooks';

const ForgotPasswordRaw = ({ className, openModal, closeModal }) => {
  const { formMethods, handleConfirm } = useForgotPassword(closeModal);

  return (
    <Box className={className}>
      <Modal
        openModal={openModal}
        closeModal={closeModal}
        DialogProps={{
          maxWidth: 'xs',
          PaperProps: {
            sx: { minWidth: '400px' },
          },
        }}
        DialogHeaderProps={{
          text: t('Forgot your password?'),
        }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="p4" color="text.500">
              {t("It's ok, it happens sometimes. Please enter your email address and we'll send you a link to choose a new one.")}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormProvider {...formMethods}>
              <form onSubmit={formMethods.handleSubmit(handleConfirm)} noValidate>
                <Grid container>
                  <Grid item xs={12}>
                    <FormEmailField
                      name="email"
                      control={formMethods.control}
                      label={<Label text={t('Business Email')} />}
                      labelText={t('Business Email')}
                      autoFocus
                      required
                      localeText={{
                        isRequired: t('IS REQUIRED'),
                        validEmailAddredd: t('Please enter a valid email address'),
                      }}
                      slotProps={{
                        htmlInput: {
                          autoComplete: 'off',
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button type="submit" variant="contained" fullWidth>
                      {t('Send me a reset link')}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </FormProvider>
          </Grid>
        </Grid>
      </Modal>
    </Box>
  );
};

ForgotPasswordRaw.propTypes = {
  className: PropTypes.string,
  openModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const ForgotPassword = styled(ForgotPasswordRaw)(styles);
ForgotPassword.propTypes = ForgotPasswordRaw.propTypes;

export default ForgotPassword;
